import React, { useState, useLayoutEffect } from 'react';
import './messages-game.css';
import {
    goBack,
    goToScreen,
    goToScreenAndReset,
    setHistoryScreenState,
} from '../../actions/router';
import { connect } from 'react-redux';
import {
    MAIN_GAME_SCREEN,
    MESSAGES_GAME_SCREEN,
    SETTINGS_SCREEN,
} from '../../constants/routes';
import { MessagesInbox } from './messages-inbox';
import { Panel } from '../../components/panel';
import { Heading } from '../../components/heading';
import { IconButton } from '../../components/icon-button';
import { Message } from './message';
import Copy from '../../copy/messages';
import { completeTutorial } from '../../actions/tutorials';
import {
    completeMessage,
    progressTime,
    updateOverallScores,
} from '../../actions/active-game';
import classNames from 'classnames';
import { TutorialModalParent } from '../../components/modal-parents/tutorial-modal';
import { ProgressUpdateModalParent } from '../../components/modal-parents/progress-update-modal';

const MessagesGameScreen = props => {
    const {
        goBack,
        goToSettings,
        continueTo,
        continueRoute,
        historyScreenState,
        tutorialCompleted,
        completeMessagesTutorial,
        previousScores,
        submitOverallScores,
        currentMessages,
        progressGame,
    } = props;

    const [activeMessage, setActiveMessage] = useState(null);
    const [step, setStep] = useState('inbox');

    const [currentGameScores, setCurrentGameScores] = useState({});
    const [progressUpdateVisible, setProgressUpdateVisible] = useState(false);
    const [responseFeedback, setResponseFeedback] = useState(null);

    const modalVisible = progressUpdateVisible || !tutorialCompleted;

    useLayoutEffect(() => {
        if (historyScreenState.screen === MESSAGES_GAME_SCREEN) {
            setActiveMessage(historyScreenState.state.activeMessage);
            setStep(historyScreenState.state.step);
        }
    }, [historyScreenState]);

    const submitResponse = (scores, feedback) => {
        setCurrentGameScores(scores);
        setResponseFeedback(feedback);
        setProgressUpdateVisible(true);
    };

    const completeGame = () => {
        if (continueRoute === MAIN_GAME_SCREEN) {
            submitOverallScores(
                previousScores,
                currentGameScores,
                activeMessage.index,
            );
            progressGame();
        }
        continueTo(continueRoute);
    };

    const messagePageClasses = classNames({
        'messages-game': true,
        'messages-game--hidden': modalVisible,
    });

    const activeMessages = currentMessages.map(i => {
        return { ...Copy.messages[i], index: i };
    });

    return (
        <>
            <div className={messagePageClasses} aria-hidden={modalVisible}>
                <IconButton
                    iconName="back"
                    size="small"
                    type="essential"
                    withSpacing={true}
                    onClick={() =>
                        step === 'inbox' ? goBack() : setStep('inbox')
                    }
                    isDisabled={modalVisible}
                />
                <Panel
                    flexDirection="column"
                    currentPage={`messages game - ${step}`}
                    key={step}
                    withPadding={false}
                >
                    <div>
                        <Heading
                            headingType="h3"
                            colorScheme="dark"
                            withSpacing={true}
                        >
                            {Copy.heading[step]}
                        </Heading>
                    </div>
                    {step === 'inbox' && activeMessages && (
                        <MessagesInbox
                            messages={activeMessages}
                            setActiveMessage={setActiveMessage}
                            setStep={setStep}
                            modalVisible={modalVisible}
                        />
                    )}{' '}
                    {step === 'message' && activeMessage && (
                        <Message
                            message={activeMessage}
                            continueTo={continueTo}
                            continueRoute={continueRoute}
                            submitResponse={submitResponse}
                            modalVisible={modalVisible}
                        />
                    )}
                </Panel>
                <IconButton
                    iconName="settings"
                    size="small"
                    type="essential"
                    withSpacing={true}
                    onClick={() => goToSettings(activeMessage, step)}
                    isDisabled={modalVisible}
                />
            </div>
            {!tutorialCompleted && (
                <TutorialModalParent
                    screen="messages"
                    onClick={() => completeMessagesTutorial()}
                />
            )}
            {progressUpdateVisible === true && (
                <ProgressUpdateModalParent
                    previousScores={previousScores}
                    gameScores={currentGameScores}
                    feedback={responseFeedback}
                    onClick={() => completeGame()}
                />
            )}
        </>
    );
};

const mapStateToProps = state => {
    return {
        continueRoute: state.router.history[state.router.history.length - 2],
        historyScreenState: state.router.historyScreenState,
        tutorialCompleted:
            state.activeGame.tutorialsCompleted[MESSAGES_GAME_SCREEN],
        previousScores: state.activeGame.overallScores,
        currentMessages: state.activeGame.currentMessages,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        goBack: () => {
            dispatch(goBack());
        },
        goToSettings: (activeMessage, step) => {
            dispatch(
                setHistoryScreenState(MESSAGES_GAME_SCREEN, {
                    activeMessage,
                    step,
                }),
            );
            dispatch(goToScreen(SETTINGS_SCREEN));
        },
        continueTo: route => {
            dispatch(goToScreenAndReset(route));
        },
        completeMessagesTutorial: () => {
            dispatch(completeTutorial(MESSAGES_GAME_SCREEN));
        },
        submitOverallScores: (previousScores, gameScores, messageIndex) => {
            dispatch(updateOverallScores(previousScores, gameScores));
            dispatch(completeMessage(messageIndex));
        },
        progressGame: () => {
            dispatch(progressTime('messages'));
        },
    };
};

const connected = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MessagesGameScreen);
export { connected as MessagesGameScreen };
